<script lang="ts" setup>
defineProps<{
  placement?: any
}>()

const $toast = useToast()
const emit = defineEmits<{
  (e: 'update', data: { url?: string; file?: File }): void
}>()

const link = ref('')
const showLink = ref(false)
const showLib = ref(false)

const options = [
  {
    label: '本地上传',
    key: 'upload',
    icon: renderIcon('bi bi-upload')
  },
  {
    label: '媒体库',
    key: 'lib',
    icon: renderIcon('bi bi-collection')
  }
]

function renderIcon(icon: string) {
  return () => {
    return h(
      'i',
      {
        class: icon
      },
      {
        default: () => h('i')
      }
    )
  }
}

function handleSelect(key: string) {
  switch (key) {
    case 'upload':
      upload()
      break
    case 'link':
      showLink.value = true
      break
    case 'lib':
      showLib.value = true
      break
    default:
      break
  }
}

function upload() {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = 'image/*'
  input.onchange = async (e) => {
    const target = e.target as HTMLInputElement
    if (target.files) {
      const file = target.files[0]
      if (!file) return
      let rowFile: File
      if (['image/gif', 'image/webp'].includes(file.type)) {
        rowFile = file
      } else {
        const { width, height } = await getImageFileSize(file)
        const longImg = height / width > 2.5
        const blob = await compressImg(file, longImg)
        rowFile = new File([blob], file.name, {
          type: file.type
        })
      }
      emit('update', {
        file: rowFile
      })
    }
  }
  input.click()
}

function onChoose(path: string) {
  showLib.value = false
  emit('update', {
    url: path
  })
}

function confirmLink() {
  if (!link.value.startsWith('https://')) {
    $toast.error('图片链接必须以https://开头')
    return
  }
  showLink.value = false
  emit('update', {
    url: link.value
  })
  link.value = ''
}

function cancelLink() {
  showLink.value = false
  link.value = ''
}
</script>

<template>
  <div class="upload-image">
    <n-dropdown
      :placement="placement || 'bottom-end'"
      trigger="click"
      size="small"
      :options="options"
      @select="handleSelect"
    >
      <slot />
    </n-dropdown>
    <m-modal
      v-model="showLink"
      title="外链图片"
      size="md"
      :cancel-fn="cancelLink"
      :confirm-fn="confirmLink"
    >
      <n-input
        v-model:value="link"
        type="text"
        placeholder="请输入图片地址，必须以https://开头"
      />
    </m-modal>
    <m-modal v-model="showLib" title="媒体库">
      <MediaLib @choose="onChoose" />
    </m-modal>
  </div>
</template>

<style lang="scss" scoped>
.upload-image {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--color-gray-400);
  &-link {
    width: 600px;
    height: 100px;
    display: flex;
    flex-direction: column;
  }
  &-button {
    margin-top: auto;
    width: 100%;
    height: 32px;
  }
}
</style>
